import React, { useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useIntl } from 'react-intl';
// Actions
import { clearRedux } from "Redux/actions";
// Components
import TagsTable from './views/tagsTable';
import DriversTable from './views/driverTable/components/table';
import DriverFaces from "./views/driverFacesTable";

const selectedEntityTable = {
  tags: <TagsTable />,
  drivers: <DriversTable />,
  driverFaces: <DriverFaces />
}

const DriverTab = () => {
  const dispatch = useDispatch();
  const selectedEntity = useSelector(state => state.driverRedux.entity);

  useEffect(() => {
    return () => {
      dispatch(clearRedux("SETTINGS_DRIVER"));
    }
  }, []);

  return (
    <div>
      { selectedEntityTable[selectedEntity?.id] }
    </div>
  );
}

export default DriverTab;